import LogoSvg from 'assets/svgs/LogoSvg';
import { LogoutSvg } from 'assets/svgs/sidebar';
import menuItems from 'constants/sidebar.constants';
import React, { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { logout } from 'redux/actions/authActions';
import { setShowSidebar } from 'redux/slices/appSlice';
import useClickOutside from 'utils/clickOutside';
import logo from '../../../assets/images/logo.png';
import "./siderbar.css";


const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const sidebarRef = useRef();
    const { user } = useSelector(state => state.auth);
  console.log('this is a user',user?.isSuperAdmin)



    const { showSidebar } = useSelector(state => state.app);
    const { loading } = useSelector(state => state.auth)
    useClickOutside(sidebarRef , () => showSidebar  ? dispatch(setShowSidebar(false)) : '')

    const closeSideBar = () => {
        if (showSidebar) {
            dispatch(setShowSidebar(false))
        }
    }

    const checkIsActive = (path, exact) => {
        const currentPath = location.pathname;
        if (exact) {
            return currentPath === path;
        }
        return currentPath.startsWith(path);
    };

    const logoutHandler = () => {
        dispatch(logout(navigate))
    }

    return (
        <div
        ref={sidebarRef} 
        className={`min-h-screen max-h-full sidebar-scroll bg-light2 fixed md:left-0 transition-all duration-300 z-50 
            overflow-y-auto ease-in-out w-[250px]
            ${showSidebar ? 'left-0' : '-left-[150%]'}
        `}>
            <div>
                <h1 className='flex items-center justify-center pt-6 pb-4'>
                
                         <img className='h-[76px]' src={logo} alt="Logo"
                          onClick={()=>navigate("/app")}
                          />
                    
                </h1>
            </div>
            <ul className='py-4 flex flex-col gap-1 '>
               <ul className='py-4 flex flex-col gap-1 '>
  {menuItems.map((item) => {
    if (item.id === 7 && !user?.isSuperAdmin) return null;

    const isActive = checkIsActive(item.path, item.exact);

    if (item.onlyText && item.path === '') {
      return (
        <p key={item.id} className='text-hint font-medium pl-5 py-3 text-xs'>
          {item.name}
        </p>
      );
    }

    return (
      <li key={item.id}>
        <Link
          to={item.path}
          className={`flex flex-row items-center py-3 pl-5 gap-2 text-sm hover:text-primary hover:fill-primary group
            ${isActive ? 'text-primary bg-gray1 border-secondary border-r-2' : 'text-dark1'}    
          `}
          onClick={closeSideBar}
        >
          <item.icon
            className={`w-[18px] 
              ${isActive ? 'fill-primary' : 'fill-dark1'} 
              group-hover:fill-primary
            `}
          />
          <p>{item.name}</p>
          {item?.separator && (
            <div className='w-[50px] h-[1px] bg-lighter mt-3 ' />
          )}
        </Link>
      </li>
    );
  })}
</ul>

                {/* <li 
                className='flex flex-col items-center py-3 gap-2 text-sm hover:text-primary group cursor-pointer'
                onClick={logoutHandler}
                >
                    {
                        loading 
                        ? 
                            <ClipLoader size={20} color='white' />
                        : 
                            <>
                                <LogoutSvg className='w-[18px] fill-pure group-hover:fill-primary' />
                                <p>Logout</p>
                            </>
                    }
                </li> */}
            </ul>
        </div>
    );
};

export default memo(Sidebar);
